import customData from '../../../../custom-settings/CustomText.json'

export function Unauthorized() {
    let unauthorizedText = customData.unauthorized;
    return <span className="fs-3">{unauthorizedText}</span>
}